module.exports = __webpack_public_path__ + "img/JBI_SUMARI-freeproduct_img@2x.baa47331.png";